import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Tabs } from "antd";

import NavigationButtons from "../sectionJobByMajor/components/NavigationButtons";
import IndustrialParkList from "./components/IndustrialParkList";
import IndustrialService from "@/services/IndustrialService";

const { TabPane } = Tabs;

const SectionLocal = () => {
  const [industrial, setIndustrial] = useState([]);
  const [tab, setTab] = useState("B");
  const location = [
    {
      key: "B",
      label: "Bắc",
    },
    {
      key: "T",
      label: "Trung",
    },
    {
      key: "N",
      label: "Nam",
    },
  ];

  useEffect(() => {
    IndustrialService.getIndustrial()
      .then((res) => {
        const filtered = res.Data.filter((item) => item.CodeKhuVuc === tab);
        const pageItem = filtered.slice(0, 24);
        setIndustrial(pageItem);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [tab]);

  const handleChangeTab = (key) => {
    setTab(key);
    setIndustrial(industrial);
  };

  return (
    <section className="">
      <div className="rounded-t-lg p-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-3 bg-gradient-to-b from-primary to-green-800 p-4 rounded-t-lg"
        // className="mb-3 bg-primary p-4 rounded-t-lg"
        >
          <div className="flex gap-4 flex-col lg:flex-row justify-between items-center mt-4">
            <div className="text-center lg:text-left w-full ">
              <h2 className="text-xl  text-white sm:text-2xl md:text-3xl font-bold mt-3 ps-2 mb-4">
                Tìm kiếm công việc theo khu công nghiệp phía:{" "}
                {location.find((item) => item.key === tab).label}
              </h2>
              <p className=" text-white ps-2">
                Tìm kiếm cơ hội việc làm phù hợp với bạn
              </p>
            </div>
            <div className="mt-4 sm:mt-0">
              <NavigationButtons prevID="prevLocal" nextID="nextLocal" />
            </div>
          </div>
        </motion.div>

        <Tabs
          defaultActiveKey={location[0].key}
          onChange={(e) => handleChangeTab(e)}
          centered
          className="bg-white p-2 sm:p-4 border border-gray-200 min-h-[600px] select-none"
        >
          {location.map((item, index) => (
            <TabPane tab={item.label} key={item.key}>
              <IndustrialParkList
                list={industrial}
                prevID="prevLocal"
                nextID="nextLocal"
              />
            </TabPane>
          ))}
        </Tabs>
      </div>
    </section>
  );
};

export default SectionLocal;
